import React from 'react';
import { AttendeeConnection } from '@graphql/gql/graphql';
import PendingCard from '@components/connections/PendingCard';
import { useTranslate } from 'nucleus-text';
import { SetConnectionAlert } from './types';
import useAcceptConnection from './hooks/useAcceptConnection';
import useDeclineConnection from './hooks/useDeclineConnection';

type Props = {
  setConnectionAlert: SetConnectionAlert;
  attendee: AttendeeConnection;
  onSelectAttendee: (attendeeId: string) => void;
  setActiveFocus: boolean;
};

/**
 * Renders a carousel of pending connections
 * @constructor
 */
function PendingCardContainer({ setConnectionAlert, attendee, onSelectAttendee, setActiveFocus }: Props): JSX.Element {
  const { translate } = useTranslate();

  const { acceptAttendeeConnection, loadingAcceptConnection } = useAcceptConnection({
    setConnectionAlert,
    analyticPageId: 'PendingConnectionList'
  });
  const { declineAttendeeConnection, loadingDeclineConnection } = useDeclineConnection({
    setConnectionAlert,
    analyticPageId: 'PendingConnectionList'
  });

  const { attendeeId, contactId, firstName, lastName, title, company, profileImageUrl } = attendee;

  return (
    <PendingCard
      key={contactId}
      contactId={contactId}
      name={translate('Universal-FullName', {
        firstName,
        lastName
      })}
      avatarName={translate('Universal-AvatarName', {
        firstName,
        lastName
      })}
      title={
        title && company
          ? translate('Profile-TitleCompany', {
              title,
              company
            })
          : title || company
      }
      profileImageUrl={profileImageUrl}
      onAccept={(): void => {
        acceptAttendeeConnection(attendeeId, contactId);
      }}
      onDecline={(): void => {
        declineAttendeeConnection(attendeeId, contactId);
      }}
      onSelectDetails={(): void => {
        onSelectAttendee(attendeeId);
      }}
      setActiveFocus={setActiveFocus}
      loadingAcceptConnection={loadingAcceptConnection}
      loadingDeclineConnection={loadingDeclineConnection}
    />
  );
}

export default PendingCardContainer;
